import React from 'react';
import { PRODUCT, SUPPORT_EMAIL } from '../data/constants';
export function Footer() {
  return <footer className="border-t-4 border-gold bg-navy py-4" data-id="element-59" data-mp="3gfsjo3v2keir">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-60" data-mp="3gh3qkcjta2e3">
        <p className="text-xs font-semibold leading-snug text-white/85 sm:text-sm" data-id="element-61" data-mp="32ovz90bar3ms">
          © 2026 {PRODUCT} — All Rights Reserved.
        </p>
        <p className="mt-1 text-xs leading-snug text-white/70 sm:text-sm" data-id="element-62" data-mp="36n3c3k2n3ksp">
          {PRODUCT} is an independent educational aviation reference resource. It is not an
          official FAA, EASA, or ICAO training program and does not provide pilot
          certification, practical flight instruction, regulatory approval, or guaranteed
          examination results. Always consult current aviation regulations, approved aircraft
          manuals, official aeronautical information, and qualified flight instructors before
          conducting flight operations.
        </p>
        <p className="mt-1.5 text-xs font-semibold uppercase tracking-wide text-white/70 sm:text-sm" data-id="element-63" data-mp="2ezl5i2sd69i5">
          Terms &amp; Conditions • Privacy Policy • Contact
        </p>
        <p className="mt-1 text-xs text-white/70 sm:text-sm" data-id="element-64" data-mp="3gbr0qn4amzel">
          Support:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-white underline decoration-gold underline-offset-2 transition-colors duration-150 ease-out hover:text-gold" data-id="element-65" data-mp="3v7zuj95f0kjm">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>;
}